import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import UserForm from './UserForm'

export default function NewUser() {
  const navigate = useNavigate()
  const goToList = useCallback(() => navigate(toPath.users()), [navigate])

  const onSubmit = useCallback(
    async (
      {
        email,
        firstName,
        lastName,
        password,
        active,
        practiceId,
        roleId,
        position,
        nationalProviderId,
      },
      { setErrors },
    ) => {
      try {
        await api.users.create({
          email,
          firstName,
          lastName,
          password,
          active,
          practiceId,
          nationalProviderId,
          roleId: roleId.key,
          position: position && position.key,
        })
        message.success('User successfully created')
        goToList()
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, error => error[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [goToList],
  )

  return (
    <div>
      <PageHeader title="New User" onBack={() => navigate(-1)} />
      <UserForm onSubmit={onSubmit} />
    </div>
  )
}
